import { render, staticRenderFns } from "./SensorInfoTabs.vue?vue&type=template&id=16e8be5c"
import script from "./SensorInfoTabs.vue?vue&type=script&lang=ts"
export * from "./SensorInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports